import React from "react";
import styled from "styled-components";
import { Typography } from "@beamcloud/design-system";
import { ICustomerTestimonial } from "types/interfaces/customers/ICustomer";
import { sanityImgBuilder } from "../sanity";
import { device } from "constants/Devices";
import { typography } from "screens/Homepage/components/typography";

interface IProps {
  testimonial: ICustomerTestimonial;
}

const Testimonial: React.FC<IProps> = ({ testimonial }) => {
  if (!testimonial) return null;

  return (
    <TestimonialContainer>
      {testimonial.image && (
        <PersonImage
          src={(testimonial.image as any).mockImageUrl || sanityImgBuilder.image(testimonial.image).url()}
          alt={testimonial.name}
        />
      )}
      <TestimonialText>{testimonial.testimonial}</TestimonialText>
      <PersonInfo>
        <PersonDetails>
          <Typography tag="h4" variant="textBase" color="gray100">
            {testimonial.name}
          </Typography>
          <Typography tag="p" variant="textSm" color="gray300">
            {testimonial.position}
          </Typography>
        </PersonDetails>
      </PersonInfo>
    </TestimonialContainer>
  );
};

export default Testimonial;

const TestimonialContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: auto;
  gap: 16px;
  padding-top: 64px;
  padding-right: 80px;
  padding-bottom: 64px;
  padding-left: 80px;
  background-color: ${props => props.theme.colors.gray2};
  margin: 48px auto;
  border-top: 1px solid ${props => props.theme.colors.gray7};
  border-bottom: 1px solid ${props => props.theme.colors.gray7};

  @media ${device.tablet} {
    padding-right: 48px;
    padding-left: 48px;
  }
`;

const TestimonialText = styled(Typography).attrs({
  tag: "div",
  variant: "title2Xl",
  color: "white"
})`
  && {
    ${typography.title22};
    text-align: center;
    vertical-align: middle;
    color: ${props => props.theme.colors.white};
  margin: 0;
  max-width: 630px;
`;

const PersonInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const PersonImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
`;

const PersonDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
